export default __webpack_public_path__ + "static/media/minibox_default.e940a443.png";